import React from 'react';
import './FundNoteTip.scss';

const RecentlyRedeemedFundNoteTip = () => (
  <div className="exclude">
    30-day purchase block due to recent redemption or exchange greater than
    $5,000.
    <a
      className="fund-note-tip-link exclude"
      href="https://www.troweprice.com/personal-investing/help/policies-and-security/trading.html#RedemptionBlock"
      target="_blank"
      rel="noopener noreferrer"
    >
      Learn more
    </a>
  </div>
);

export default RecentlyRedeemedFundNoteTip;
